export const RES_COMMON_CODE = {
  INIT: 0, //无意义的初始错误码
  SUCCESS: 200,
  TOKEN_EXPIRE: 501,//token过期
  NO_PERMISSION: 502, //没有相关权限
  NO_REGISTER: 503,//用户未注册
  BALANCE_NOT_ENOUGH: 518, //余额不足
  LOTTERY_RESULT_TIMEOUT: 530, //开奖超时
  RESCODE_OPERATION_LIMIT: 544,//用户操作次数受限
  RESCODE_LIMIT_TIME: 560,//未到下注时间
  TIMES_LIMIT: 565,//次数受限
  LIMIT_CLICK_OTHER: 717,//只允许点击同一个
  NO_CP: 718,//没有CP
  ACTIVITY_INVALID: 900,//没有可用活动
  ACTIVITY_EXPIRED: 903, //活动已过期
  SPEND_CURRENCY_FAILED: 906, //消费资产失败
  GOOD_ALREADY_SOLD: 915, //商品已出售
  ADD_ANCHOR_OVER_LIMIT: 932, //新增主播数超过限制
  AGENCY_NO_ACTIVE: 939,//工会未实名
  ADD_ANCHOR_NOTMEET_CONDITION: 934, //不能添加不符合条件的主播
  ADD_ANCHOR_NOT_ADDANCHOR_TIME: 936, //当前时间不能新增主播
  ANCHOR_MONTH_SLALARY_NOT_VERIFIED: 965, //月度工资未结算完成
  C_NET_QEQUEST_ERROR: 1501,
  C_PARAM_ERROR: 1502, //参数错误
  C_FILE_UPLOAD_FAILED: 1503, //文件上传失败
  TOO_LITTLE_TO_WITHDRAW_PERTIME: 3018, //单次提现太少金额
  TOO_MUCH_TO_WITHDRAW_PERTIME: 3019, //单次提现太多金额
  TOO_MUCH_TO_WITHDRAW_PERMONTH: 3020, //单月提现太多金额
  TOO_FREQUENCY_TO_ISSUE_WITHDRAW: 3021, //提现请求太频繁
  CANT_INVITE_NEWCP_TO_MIC: 3035,//不能邀请新的CP上麦
  NOT_VALID_INTIMACY: 3040,//不是有效的亲密关系
  USER_NO_CPINTIMACY: 3038,//用户没有CP关系
  ACTIVITY_SIGNUP_OVER: 3039,//活动报名已经截止
  CANT_RENEW_EXPIRED_VIP: 3050,//不能续期已经过期的贵族
  VIP_DURATION_OVERLIMIT: 3052,//用户贵族过期时间已经超出最大限制
  WITHDRAW_VERIFY: 3890, // 充值,转账后台审批
  ID_INPUT_ERROR: 4024,//ID输入错误
  CODE_ERROR: 4025,//验证码错误
  CODE_INVALID: 4026,//验证码无效
  RESCODE_CP_BY_RING_TIP: 4086, //满足求婚条件的CP才可以购买戒指
  RESODE_CP_PROPOSAL_ING: 4087, //正在求婚中或者未求婚
  MARRIAGE_EXPIRED: 4088, //发出的结婚已过期
};